import Sentry from 'lib/sentry';
import Vue from 'vue';

const initialState = {
  sections: {},
};

const getters = {
  getSections: (state) => state.sections,
};

const actions = {
  async fetchSectionByCategory({commit}, {category}) {
    try {
      commit('setAppLoading', true, {root: true});
      const {data: sections} = await this.$api.getDynamicSection({category});
      commit('setSectionCategory', {category, sections});
      return sections;
    } catch (error) {
      commit('setSectionCategory', {category, sections: []});
      Sentry.log('fetchSectionByCategory', error);
    } finally {
      commit('setAppLoading', false, {root: true});
    }
  },
};

const mutations = {
  setSectionCategory(state, {category, sections}) {
    Vue.set(state.sections, category, sections);
  },
};

export default {
  namespaced: true,
  state: {...initialState},
  getters,
  actions,
  mutations,
};
